import { forwardRef, type Ref, type SVGProps } from "react";
const IconSearchOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m29.71 28.29-6.55-6.55a12 12 0 1 0-1.41 1.41l6.55 6.55a1 1 0 0 0 1.42 0 1 1 0 0 0-.01-1.41M14 24a10 10 0 1 1 10-10 10 10 0 0 1-10 10"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSearchOutlineSVG);
ForwardRef.displayName = "IconSearchOutline";
export { ForwardRef as IconSearchOutline };
